
import requestPasswordReset from '~/graphql/mutations/auth/requestPasswordReset.gql';

export default {
  layout: 'login',
  middleware: 'guest',
  auth: false,
  data: () => ({
    email: '',
  }),
  methods: {
    async request() {
      try {
        await this.$apollo.mutate({
          mutation: requestPasswordReset,
          variables: {
            email: this.email,
          },
        }).then(({data}) => {
          if (data.requestPasswordReset) {
            this.$toast.success('Er is een reset link gestuurd naar het e-mailadres.');
          } else {
            this.$toast.error('Er is iets fout gegaan tijdens het aanvragen van de wachtwoord reset.');
          }
        });

        await this.$router.push(this.localePath({name: 'index'}));
      } catch (e) {
        this.$toast.error('Er is iets fout gegaan tijdens het aanvragen van de wachtwoord reset.');
      }
    },
  },
};
